// extracted by mini-css-extract-plugin
module.exports = {"all":"e_tq","accent":"e_uq"};